import {default as Component} from './AddDomainResourceControl'
import {showModalPopup} from '../../redux/actions'
import {connect} from 'react-redux'
import {MODAL_POPUP_ID} from '../../redux/const'

const AddDomainResourceControl = connect(
	(state) => ({
		visible: state.login.isLoggedIn
	}),
	(dispatch) => ({
		click: () => {
			dispatch(showModalPopup(MODAL_POPUP_ID.ADD_DOMAIN_RESOURCE))
		}
	})
)(Component)

AddDomainResourceControl.defaultProps = {
	visible: null,
	click: null,
}

export default AddDomainResourceControl


// WEBPACK FOOTER //
// ./src/components/AddDomainResourceControl/index.js